import { Component,Input } from '@angular/core';

/**
 * Generated class for the IngredientsMeasurementComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'ingredients-measurement',
  templateUrl: 'ingredients-measurement.html'
})
export class IngredientsMeasurementComponent {
    @Input() measurement;

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/ingredients-measurement/ingredients-measurement.ts